import { Controller } from 'stimulus'
import {
    removeElement,
} from "helpers";


export default class extends Controller {
    static targets = ["begone"]
    
    alv(event) {
        let ele = this.element        

        event.preventDefault()
        console.log(ele)
        removeElement(ele)
    }
}